module.exports = "/fonts/vendor/@mdi/materialdesignicons-webfont.woff2?412de0a2eeaa5521c0bb19d13bc23a8b";